import { GraphSplitAdapter } from "../../../../../graphics/graph-split-adapter";
import { RawMinMaxCalculator } from "@incartdev/jagm-chart";

export class measurerGraphMainAdapter extends GraphSplitAdapter {
    updateTabelValuesCallback;
    updateCursorAreaCallback;
    minMaxCalculator;

    leftMeasurer;
    rightMeasurer;
    cursorStart;
    cursorEnd;

    lefthoverRect;
    righthoverRect;

    signalLength;

    constructor(props) {
        super(props);
        this.updateTabelValuesCallback = props.updateTabelValuesCallback;
        this.updateCursorAreaCallback = props.updateCursorAreaCallback;
        this.signalLength = props.signalLength;

        this.minMaxCalculator = new RawMinMaxCalculator();
    }

    setupRectangles = async () => {
        const contentGroups = this.chartProvider.charts;

        contentGroups.forEach((item, index) => {
            const rectContentGroup = item.findContentGroup("rectangle");
            if (rectContentGroup !== undefined) {
                const rectGroup = rectContentGroup;
                const hover = rectGroup.findByName("hovered");
                if (index === 0) {
                    this.leftHoverRect = hover;
                } else {
                    this.rightHoverRect = hover;
                }
            }
        });
    };

    setupMeasurers = async () => {
        const contentGroups = this.chartProvider.charts;

        contentGroups.forEach((item, index) => {
            const measurerContentGroup = item.findContentGroup("measurer");
            if (measurerContentGroup !== undefined) {
                const measurerGroup = measurerContentGroup;
                const measurer = measurerGroup.findByName("measurer");
                if (measurer !== undefined) {
                    if (index === 0) {
                        this.leftMeasurer = measurer;
                    } else {
                        this.rightMeasurer = measurer;
                    }
                }
            }
        });

        if (this.leftMeasurer) {
            this.leftMeasurer.addEventListener("PositionChanged", async target =>
                this.onPositionChanged(target, this.rightMeasurer, this.leftMeasurer)
            );
        }

        if (this.rightMeasurer) {
            this.rightMeasurer.addEventListener("PositionChanged", async target =>
                this.onPositionChanged(target, this.leftMeasurer, this.rightMeasurer)
            );
        }

        await this.centerCursors();
    };

    updateTabelValues = () => {
        const totalMinMax = [];
        const leftAmplitude = [];
        const rightAmplitude = [];
        this.chartProvider.signalObjectGroups.forEach(signalGroup => {
            signalGroup.forEachSignal(signal => {
                const buffer = signal.getBuffer();
                const leftDataId = buffer.getLastDataIdByX(this.cursorStart * window.devicePixelRatio);
                const rightDataId = buffer.getLastDataIdByX(this.cursorEnd * window.devicePixelRatio);

                const minMax = this.minMaxCalculator.getMinMax(leftDataId, rightDataId, buffer);

                const leftValue = buffer.getData(leftDataId);
                const rightValue = buffer.getData(rightDataId);

                leftAmplitude.push(leftValue);
                rightAmplitude.push(rightValue);
                totalMinMax.push(minMax);
            });
        });

        this.updateTabelValuesCallback({
            amplStart: leftAmplitude,
            amplEnd: rightAmplitude,
            amplRange: totalMinMax
        });
    };

    centerCursors = async () => {
        const graphWidth = this.valueConverter.convertPointsToPixels(this.getWidthInPoints(this.fd), this.fd);
        const areawidth_initial = this.convertMsToPixels(250);
        const startSelectPx = Math.round(graphWidth - areawidth_initial) / 2;
        const endSelectPx = startSelectPx + areawidth_initial;
        // Двигаем один, т.к. второй подвинется сам - благодаря эвентам
        this.cursorStart = startSelectPx;
        this.cursorEnd = endSelectPx;
        await this.leftMeasurer.move({ leftLinePosition: startSelectPx, rightLinePosition: endSelectPx });
    };

    updateCursorArea = areaWidthInMs => {
        const areaWidthInPixels = this.convertMsToPixels(areaWidthInMs);
        const graphWidthInPixels = this.valueConverter.convertPointsToPixels(this.getWidthInPoints(this.fd), this.fd);
        this.cursorEnd = this.cursorStart + areaWidthInPixels;

        if (this.cursorEnd > graphWidthInPixels) {
            this.cursorEnd = graphWidthInPixels;
            this.cursorStart = graphWidthInPixels - areaWidthInPixels;
        }

        if (this.cursorStart < 1) {
            this.cursorStart = 1;
        }

        const newAreaWidthInMs = this.convertPixelsToMs(this.cursorEnd - this.cursorStart);
        this.updateCursorAreaCallback(newAreaWidthInMs);
        this.moveCursors(this.cursorStart, this.cursorEnd);
    };

    moveSelectRectangles = async (x, width) => {
        const xInPx = this.valueConverter.convertPointsToPixels(x, this.fd);
        const widthInPx = this.valueConverter.convertPointsToPixels(width, this.fd);
        await Promise.all([
            this.leftHoverRect.move(xInPx),
            this.leftHoverRect.resize(widthInPx),
            this.rightHoverRect.move(xInPx),
            this.rightHoverRect.resize(widthInPx)
        ]);
    };

    hideSelectRectangles = async isVisible => {
        await Promise.all([this.leftHoverRect.setVisibility(isVisible), this.rightHoverRect.setVisibility(isVisible)]);
    };

    moveCursors = async (start, end) => {
        await Promise.all([
            this.leftMeasurer.moveWithoutEvent({ leftLinePosition: start, rightLinePosition: end }),
            this.rightMeasurer.moveWithoutEvent({ leftLinePosition: start, rightLinePosition: end })
        ]);
    };

    onPositionChanged = async (target, oppositeCursor, mainCursor) => {
        const { x: start, width } = target.position;
        const signalLengthInPixels = this.valueConverter.convertPointsToPixels(this.signalLength, this.fd);

        const end = start + width;

        this.cursorEnd = Math.min(end, signalLengthInPixels);
        this.cursorStart = this.cursorEnd - width;

        mainCursor.moveWithoutEvent({
            leftLinePosition: this.cursorStart,
            rightLinePosition: this.cursorEnd
        });

        oppositeCursor.moveWithoutEvent({
            leftLinePosition: this.cursorStart,
            rightLinePosition: this.cursorEnd
        });

        this.updateCursorAreaCallback(this.convertPixelsToMs(this.cursorEnd - this.cursorStart));
        this.updateTabelValues();
    };
}
